<template>
  <modal
    title="Create New Loyalty Scheme"
    width="35"
    :showModal="showModal"
    @close-modal="closeModal"
  >
    <div class="">
      <label class="label">Prefix Format:</label>
      <input type="text" class="input" placeholder="Enter" />
    </div>
    <div class="">
      <label class="label">Suffix Format:</label>
      <input type="text" class="input" placeholder="Enter" />
    </div>
    <div class="">
      <label class="label">Root Format:</label>
      <input type="text" class="input" placeholder="Enter" />
    </div>
    <div class="">
      <label class="label">Code Seperator:</label>
      <input type="text" class="input" placeholder="Enter" />
    </div>
    <div class="actions flex justify-between">
      <div>
        <p>Cancel</p>
      </div>
      <div>
        <primary-button buttonText="Save" :loading="loading" />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    closeModal() {
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped></style>
